import React from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '../components/Tooltip';

export interface AppointmentsEntryButtonProps {
    /** Upcoming (non-canceled, date >= today) appointment count for the badge. */
    upcomingCount: number;
    onClick: () => void;
    /** Overrides the default button chrome (size, border, radius). */
    className?: string;
    /** Overrides the default icon size. */
    iconClassName?: string;
}

export const AppointmentsEntryButton: React.FC<AppointmentsEntryButtonProps> = ({
    upcomingCount,
    onClick,
    className,
    iconClassName
}) => (
    <Tooltip content="Appointments">
        <button
            type="button"
            onClick={onClick}
            aria-label="Appointments"
            className={
                className ??
                'relative h-[42px] w-[42px] grid place-items-center rounded-lg border border-gray-200 bg-white text-gray-600 hover:border-gray-400 hover:text-gray-900 transition-colors'
            }
        >
            <CalendarDaysIcon className={iconClassName ?? 'h-6 w-6'} />
            {upcomingCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 grid place-items-center rounded-full bg-yellow-400 text-[10px] font-semibold text-gray-900">
                    {upcomingCount}
                </span>
            )}
        </button>
    </Tooltip>
);

export default AppointmentsEntryButton;
